import React from 'react';

const SortOldestIcon = ({ style, onClick }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: '16px', height: '16px', cursor: 'pointer', ...style }}
        onClick={onClick}
    >
        <path d="M3 4h18M3 10h12M3 16h6" />
        <path d="m18 8-3-3-3 3" />
    </svg>
);

export default SortOldestIcon;
